import type { CSSProperties, ReactNode } from 'react'

export const GBtn = ({ children }: { children: ReactNode }) => (
  <span className="pd-gbtn">{children}</span>
)

export const Section = ({ id, children, style }: { id?: string; children: ReactNode; style?: CSSProperties }) => (
  <section
    id={id}
    style={{ position: 'relative', maxWidth: 1200, margin: '0 auto', padding: 'clamp(70px,9vw,120px) 28px', ...style }}
  >
    {children}
  </section>
)

type EyebrowColor = 'primary' | 'secondary' | 'accent'
export const Eyebrow = ({ children, color = 'primary' }: { children: ReactNode; color?: EyebrowColor }) => (
  <div
    className="fmono"
    style={{ textTransform: 'uppercase', letterSpacing: '.18em', fontSize: '.8rem', fontWeight: 600, color: `hsl(var(--${color}))`, marginBottom: 16 }}
  >
    {children}
  </div>
)
